import { format } from 'date-fns';
import { useContext } from 'react';
import { CalenderContext, CalenderContextType } from './CalenderContext';

export default function CalenderTitle() {
  const { today } = useContext(CalenderContext) as CalenderContextType;
  return (
    <h1 className="text-xl font-semibold">
      {format(today, 'MMMM')} {format(today, 'y')}
    </h1>
  );
}
